// extracted by mini-css-extract-plugin
export var searchHeader = "_64-0";
export var searchHeaderDark = "_64-1";